export const ENVIRONMENT = 'ENVIRONMENT';